var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('highcharts',{ref:"chart",attrs:{"options":_vm.options}}),_c('br'),_c('b-table',{attrs:{"striped":true,"narrowed":true,"hoverable":true,"data":_vm.values,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }